export default "__VITE_ASSET__DX5ooTWN__"